module.exports = __webpack_public_path__ + "img/ecole-mont-bleu.678dbdc8.webp";